export default __webpack_public_path__ + "static/media/dashboard-img1.62092a69.svg";